import { render } from "./GanttGridBorders.vue?vue&type=template&id=a977c5e8"
import script from "./GanttGridBorders.vue?vue&type=script&lang=ts"
export * from "./GanttGridBorders.vue?vue&type=script&lang=ts"
script.render = render

export default script